// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__mon3X","modalForm":"UpgradeEpcsModal_modalForm__1F5Gb","modalFooter":"UpgradeEpcsModal_modalFooter__2Bgni"};